module.exports = __webpack_public_path__ + "img/svgArrowBottom.13a37f2c.svg";